import { getTableColumns } from 'helpers';

const StudyChampionsColumns = [
  ['ctepId', 'string', 'Group', 'left', true],
  ['ctepPersonId', 'string', 'CTEP Person Id', 'left', true],
  ['lastName', 'string', 'Last Name', 'left', true],
  ['firstName', 'string', 'First Name', 'left', true],
  ['middleName', 'string', 'Middle Name', 'left', true],
  ['createdDate', 'date', 'Created Date', 'left', true]
];


export default getTableColumns(StudyChampionsColumns);
